import React from 'react';
import '../../styles/AptitudeText.css';

export default function AptitudeText() {
  return (
    <div className="aptitude-text">
      <h3>적성·흥미 검사 결과 분석</h3>
      <p>
        학생의 적성과 흥미를 종합적으로 분석한 결과, 탐구형(I)과 기업형(E) 성향이 두드러집니다. 
        탐구형 성향은 논리적 사고와 분석적 접근을 선호하며, 이학/공학/의학계열의 학과에 적합합니다. 
        기업형 성향은 리더십과 목표지향성을 보여주며, 경상/사회/법/정치/행정계열의 학과가 적합합니다.
      </p>
      <p>
        또한 예술시각능력과 자연친화력에서 높은 적성을 보여, 예술/디자인/미술계열과 자연/생명/농림/환경계열의 학과도 고려해볼 수 있습니다. 
        이러한 결과를 바탕으로 학생에게는 수학과, 컴퓨터공학과, 시각디자인학과, 생명과학과, 환경공학과 등을 추천합니다.
      </p>
    </div>
  )
}
